import { render, staticRenderFns } from "./PlannerDemographic.vue?vue&type=template&id=5a04184b&scoped=true&"
import script from "./PlannerDemographic.vue?vue&type=script&lang=js&"
export * from "./PlannerDemographic.vue?vue&type=script&lang=js&"
import style0 from "./PlannerDemographic.vue?vue&type=style&index=0&id=5a04184b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04184b",
  null
  
)

export default component.exports